(() => {
  const currencyFormatter = () =>
    new Intl.NumberFormat(Shopify.locale, {
      style: 'currency',
      currency: Shopify.currency.active,
    });

  const currencyRate = () => Number(Shopify.currency.rate || 1);

  const numberFromData = (value) => {
    if (value === undefined || value.trim() === '') return Number.NaN;

    return Number(value);
  };

  class ShippingCommunicationAmount extends HTMLElement {
    connectedCallback() {
      const baseAmount = numberFromData(this.dataset.baseAmount);

      if (!Number.isFinite(baseAmount)) return;

      this.textContent = currencyFormatter().format(baseAmount * currencyRate());
    }
  }

  class ShippingCommunicationMessage extends HTMLElement {
    connectedCallback() {
      const template = this.dataset.template || '';
      const baseAmount = numberFromData(this.dataset.baseAmount);

      if (!template) {
        this.hidden = true;
        return;
      }

      const amount = Number.isFinite(baseAmount)
        ? currencyFormatter().format(baseAmount * currencyRate())
        : '';

      this.textContent = template.replaceAll('[amount]', amount);
    }
  }

  class ShippingCommunicationSummary extends HTMLElement {
    connectedCallback() {
      const rate = currencyRate();
      const baseThreshold = numberFromData(this.dataset.baseThreshold);
      const baseShippingCost = numberFromData(this.dataset.baseShippingCost);
      const shippingTotal = numberFromData(this.dataset.shippingTotal);
      const cartTotal = numberFromData(this.dataset.cartTotal);
      const freeShippingEnabled = this.dataset.freeShippingEnabled === 'true';
      const hasThreshold = Number.isFinite(baseThreshold);
      const hasShippingCost = Number.isFinite(baseShippingCost);
      const convertedThreshold = hasThreshold ? Math.round(baseThreshold * 100 * rate) : null;
      const convertedShippingCost = hasShippingCost ? Math.round(baseShippingCost * 100 * rate) : 0;
      const qualifiesForFreeShipping =
        freeShippingEnabled && hasThreshold && shippingTotal >= convertedThreshold;
      const formatter = currencyFormatter();

      const subtotalRow = this.querySelector('[data-shipping-subtotal-row]');
      const freeShippingLabel = this.querySelector('[data-free-shipping-label]');
      const shippingCostAmount = this.querySelector('[data-shipping-cost-amount]');
      const shippingAtCheckout = this.querySelector('[data-shipping-at-checkout]');
      const total = this.querySelector('[data-cart-total]');

      if (subtotalRow) subtotalRow.hidden = qualifiesForFreeShipping;
      if (freeShippingLabel) freeShippingLabel.hidden = !qualifiesForFreeShipping;

      if (shippingCostAmount) {
        shippingCostAmount.hidden = qualifiesForFreeShipping || !hasShippingCost;
        shippingCostAmount.textContent = formatter.format(convertedShippingCost / 100);
      }

      if (shippingAtCheckout) {
        shippingAtCheckout.hidden = qualifiesForFreeShipping || hasShippingCost;
      }

      if (total && Number.isFinite(cartTotal)) {
        const displayedShippingCost = qualifiesForFreeShipping ? 0 : convertedShippingCost;
        total.textContent = formatter.format((cartTotal + displayedShippingCost) / 100);
      }
    }
  }

  class ProductShippingCommunication extends HTMLElement {
    connectedCallback() {
      const baseThreshold = numberFromData(this.dataset.baseThreshold);
      const variantPrice = numberFromData(this.dataset.variantPrice);

      if (!Number.isFinite(baseThreshold) || !Number.isFinite(variantPrice)) return;

      const convertedThreshold = Math.round(baseThreshold * 100 * currencyRate());
      const qualifiesForFreeShipping = variantPrice >= convertedThreshold;
      const freeShipping = this.querySelector('[data-free-shipping]');
      const standardShipping = this.querySelector('[data-standard-shipping]');

      if (freeShipping) freeShipping.hidden = !qualifiesForFreeShipping;
      if (standardShipping) standardShipping.hidden = qualifiesForFreeShipping;
    }
  }

  if (!customElements.get('shipping-communication-amount')) {
    customElements.define('shipping-communication-amount', ShippingCommunicationAmount);
  }

  if (!customElements.get('shipping-communication-message')) {
    customElements.define('shipping-communication-message', ShippingCommunicationMessage);
  }

  if (!customElements.get('shipping-communication-summary')) {
    customElements.define('shipping-communication-summary', ShippingCommunicationSummary);
  }

  if (!customElements.get('product-shipping-communication')) {
    customElements.define('product-shipping-communication', ProductShippingCommunication);
  }
})();
